// src/hooks/userHooks.js
import { useEffect, useState } from "react";

const useProfile = () => {
  // ✅ Directly get from localStorage
  const userProfileSession = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(userProfileSession);

  useEffect(() => {
    const storedUser = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;
    const storedToken = localStorage.getItem("token");

    setUserProfile(storedUser);
    setLoading(storedToken ? false : true);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
